<header class="hv3-topbar">
  <button type="button" class="hv3-menu-toggle hv2-mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Open menu">
    <i class="ph ph-list"></i>
  </button>

  <div class="hv3-progress" tabindex="0" role="button"
    [attr.aria-label]="'School profile ' + classConfigPercentage + '% complete'"
    (click)="openClassConfigPopup()" (keydown.enter)="openClassConfigPopup()"
    *ngIf="loginMode == 'WEB_ADMIN' && isFranchise == 0">
    <div class="hv3-pp-pill">
      <span class="hv3-pp-ring">
        <svg viewBox="0 0 44 44" aria-hidden="true">
          <circle class="hv3-pp-track" cx="22" cy="22" r="18"></circle>
          <circle class="hv3-pp-fg" cx="22" cy="22" r="18"
            [style.stroke-dasharray]="ringCircumference"
            [style.stroke-dashoffset]="ringOffset"></circle>
        </svg>
        <b>{{ classConfigPercentage }}%</b>
      </span>
      <span class="hv3-pp-text">
        <b>{{ 'schoolConfigured' | translate:{ percent: classConfigPercentage } }}</b>
        <small>{{ 'viewDetails' | translate }}</small>
      </span>
      <span class="hv3-pp-go" (click)="openClassConfigPopup()"><i class="ph ph-bold ph-arrow-right"></i></span>
    </div>
  </div>

  <div class="hv3-greeting">
    <h1>{{ greetingPeriod | translate }}, {{ loginMode == 'WEB_ADMIN' ? ('admin' | translate) : staffName }}</h1>
    <p>{{ currentDate | date:'EEEE, d MMMM y' }}</p>
  </div>

  <div class="hv3-topbar-right">
    <app-language-dropdown iconStyle="globe"></app-language-dropdown>

    <button *ngIf="loginMode == 'WEB_ADMIN' && permissions.TAKE_ADMISSIONS == 'ENABLED'"
      class="hv3-btn-primary" data-toggle="modal" data-target="#newadmission-v2">
      <i class="ph ph-bold ph-plus"></i>
      <span>{{ 'header.new' | translate }} {{ 'header.admission' | translate }}</span>
    </button>

    <span class="hv3-divider" aria-hidden="true"></span>

    <div class="dropdown hv3-school-dropdown">
      <button class="hv3-school dropdown-toggle" data-toggle="dropdown">
        <img *ngIf="schoolImage" [src]="schoolImage" alt="" class="hv3-crest hv3-crest-img" />
        <span *ngIf="!schoolImage" class="hv3-crest">{{ profileInitials }}</span>
        <span class="hv3-school-text">
          <b>{{ loginMode == 'WEB_ADMIN' ? schoolName : staffName }}</b>
          <small *ngIf="loginMode == 'WEB_ADMIN'">{{ schoolLocality }}, {{ schoolState }}</small>
        </span>
        <i class="ph ph-caret-down"></i>
      </button>
      <ul class="dropdown-menu animation-dock">
        <li class="dropdown-header">{{ 'header.signedInAs' | translate }} <b>{{ loginMode == 'WEB_ADMIN' ? schoolName : staffName }}</b></li>
        <li *ngIf="loginMode == 'WEB_ADMIN' && permissions.SETTINGS_MANAGEMENT == 'ENABLED'">
          <a style="cursor: pointer" [routerLink]="['/settings']">{{ 'header.profile' | translate }}</a>
        </li>
        <li class="divider"></li>
        <li><a (click)="logout()" style="cursor: pointer"><i class="ph ph-sign-out text-danger"></i> {{ 'header.logout' | translate }}</a></li>
      </ul>
    </div>
  </div>
</header>
